import React, { useEffect, useState } from 'react'
import { getF1AggregatorfinancialDetails, getcategorizeTransactionBYTypeUserId, getF1StatusAggregatorfinancialDetails } from '../AdminActionCreator.component'
import { formatCurrency, formatDateLatest } from '../../../../utils/commonUtility'
import Nodata from '../../../../images/nodata.png'
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'

const itemsPerPage = 5;
export default function AggregatorComponent({ allDetail,customHeaderTenant }) {
  const [loader, setLoader] = useState(false)
  const [DetailsData, setDetailsData] = useState({ parsedData: {}, accountData: {}, holderData: {}, transactions: [] })
  const [currentType, setcurrentType] = useState("")
  const [viewDataType, setViewDataType] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [paginatedData, setPaginatedData] = useState([]);
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });

  useEffect(() => {
    getF1StatusAggregatorfinancialDetailsFn()
    getcategorizeTransactionBYTypeUserIdFn(currentType)
  }, [])

  const getF1StatusAggregatorfinancialDetailsFn = () => {
    getF1StatusAggregatorfinancialDetails(allDetail?.userId, "1",customHeaderTenant, callback => {
      if (callback?.status == 200 && callback?.message == "success") {
        if (callback?.data != "Data Not found" && callback?.data != "Account Aggregator Data not found") {
          getF1AggregatorfinancialDetailsFn(0)
        } else {
          setPopup({ show: true, popupStatus: callback?.data })
          removePopup()
        }
      }
    })
  }

  const getF1AggregatorfinancialDetailsFn = (value) => {
    setLoader(true)
    getF1AggregatorfinancialDetails(allDetail?.userId,value,customHeaderTenant, callback => {
      setLoader(false)
      if (callback?.message == "success" && callback?.status == 200) {
        const parsedData = JSON.parse(callback?.data)?.[0];
        const accountData = parsedData?.accounts?.[0]?.data?.account;
        const holderData = accountData?.profile?.holders?.holder?.[0];
        // const transactions = accountData?.transactions?.transaction;

        setDetailsData(prev => ({
          ...prev,
          parsedData: parsedData,
          accountData: accountData,
          holderData: holderData,

        }))
      } else {
        setViewDataType(false)
        setDetailsData({ accountData: {}, holderData: {}, transactions: [], parsedData: {} })
        setPaginatedData([])
      }
    })
  }

  const getcategorizeTransactionBYTypeUserIdFn = (type) => {
    setLoader(true)
    getcategorizeTransactionBYTypeUserId(type, allDetail?.userId,customHeaderTenant, callback => {
      setLoader(false)
      console.log("call", callback)
      if (callback?.message == "success" && callback?.status == 200 && callback?.data?.length > 0) {
        setDetailsData((prev) => ({
          ...prev,
          "transactions": callback?.data
        }))
        paginate(callback?.data, 1);
      } else {
        setDetailsData((prev) => ({
          ...prev,
          "transactions": []
        }))
        setPaginatedData([])
      }

    })
  }

  const handleType = (type) => {
    setcurrentType(type)
    setCurrentPage(1)
    getcategorizeTransactionBYTypeUserIdFn(type)
  }

  const handlePagePagination = (e, value) => {
    setCurrentPage(value);
    paginate(DetailsData?.transactions, value);
  };

  const paginate = (data, page) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const sliced = data.slice(startIndex, endIndex);
    setPaginatedData(sliced);
  };

  const closePopup = () => {
    setPopup({ show: false, popupStatus: '' })
  }

  const removePopup = () => {
    setTimeout(() => {
      closePopup()
    }, 5000)
  }

  const handleRegenrate =()=>{
   getF1AggregatorfinancialDetailsFn(1)
  }

  return (
    <>

      {loader ?
        <Loader />
        : ''}

      {
        popup?.show ?
          <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
        :''}
        <div style={{display:'flex',justifyContent:'end',marginBottom:'10px'}}>
          <button className='btn btn-primary' onClick={()=>handleRegenrate()}>Regenerate</button>
        </div>
      {
        viewDataType ?
          <>

            <div style={{ backgroundColor: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '#f0fdf4' : "#fdf0f0", borderRadius: '0.5rem', padding: '15px', border: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '1px solid #bbf7d0' : '1px solid #f7bbbb' }}>
              <h3 style={{ fontWeight: '600', color: '#1f2937', margin: ' 0 0 20px 0', fontSize: '20px' }}>Account Details</h3>
              <div style={{ display: 'grid', gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: '1rem', fontSize: '0.875rem', lineHeight: '1.25rem' }}>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Holder</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.name}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Number</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.parsedData?.accounts?.[0]?.maskedAccNumber}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Type</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.type}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>IFSC Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.ifscCode}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Branch</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.branch}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Status</p>
                  <p style={{ color: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '#16a34a' : "#ff4c4c", fontSize: '14px', fontWeight: '500' }}>{DetailsData?.accountData?.summary?.status}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Current Balance</p>
                  <p style={{ color: '#16a34a', fontSize: '14px', fontWeight: '700' }}>{formatCurrency(DetailsData?.accountData?.summary?.currentBalance)}</p>
                </div>

                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>MICR Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.micrCode}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Mobile</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.mobile}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>PAN</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.pan}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Address</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.address}</p>
                </div>

              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: '0.5rem', border: '1px solid  #e5e7eb', margin: '20px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eff6ff', padding: '15px' }}>
                <h3 style={{ fontWeight: '600', color: '#1f2937', margin: '0', fontSize: '20px' }}>Recent Transactions</h3>
                <select value={currentType} onChange={(e) => handleType(e.target.value)} style={{ width: '100px', padding: '10px', border: '1px solid #D3D9E9', borderRadius: '5px' }}>
                  <option value="">All</option>
                  <option value="credit">Credit</option>
                  <option value="debit">Debit</option>
                </select>
              </div>
              {
                paginatedData && paginatedData?.length > 0 ?
                  <>
                    <div className='customFinanceTable'>
                      <table>
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>Date</th>
                            <th style={{ textAlign: "center" }}>Description</th>
                            <th style={{ textAlign: "center" }}>Type</th>
                            <th style={{ textAlign: "right" }}>Amount</th>
                            <th style={{ textAlign: "right" }}>Balance</th>
                          </tr>
                        </thead>
                        <tbody className="custom-divide-y">
                          {paginatedData.map((txn, index) => (
                            <tr key={index}>
                              <td style={{ textAlign: "left" }}>{formatDateLatest(txn?.valueDate)}</td>
                              <td>{txn?.narration || ""}</td>
                              <td>
                                <span
                                  style={{
                                    display: 'inline-flex', padding: '8px', fontWeight: '500', borderRadius: '6px',
                                    background: txn?.type === 'CREDIT' ? "#d1fae5" : "#fee2e2",
                                    color: txn?.type === 'CREDIT' ? "#065f46" : "#991b1b"
                                  }}
                                >
                                  {txn?.type || ""}
                                </span>
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: '500', color: txn?.type == "CREDIT" ? "16a34a" : "#dc2626" }}>
                                {txn.type === 'CREDIT' ? '+' : '-'}{formatCurrency(txn?.amount)}
                              </td>
                              <td style={{ fontWeight: '500', textAlign: 'right' }}>
                                {formatCurrency(txn?.currentBalance)}
                              </td>
                            </tr>
                          ))
                          }
                        </tbody>
                      </table>
                    </div>
                    <div style={{ margin: '15px', display: 'flex', justifyContent: 'end' }}>
                      <Pagination
                        count={Math.ceil(DetailsData?.transactions?.length / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePagePagination}
                        variant="outlined"
                        color="primary" shape="rounded"
                      />
                    </div>
                  </>
                  :
                  <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    <img src={Nodata} style={{ width: '40%' }} />
                  </div>}
            </div>

          </>
          :
          <h3 style={{ marginTop: '40px' }} className="text-center"><img src={Nodata} width="300px" /></h3>
      }


    </>
  )
}
